import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ShowCard from '@/components/base/ShowCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import SchemaOrg from '@/components/base/SchemaOrg';
import { categories, shows } from '@/mocks/shows';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const activeSlug = slug || 'all';

  const [filteredShows, setFilteredShows] = useState(shows);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (activeSlug === 'all') {
      setFilteredShows(shows);
    } else {
      setFilteredShows(shows.filter((s) => s.categorySlug === activeSlug));
    }
  }, [activeSlug]);

  const handleCategoryChange = (newSlug: string) => {
    navigate(`/category/${newSlug}`);
  };

  const currentCategory = categories.find((c) => c.slug === activeSlug);
  const categoryName = currentCategory ? currentCategory.name : '全部';

  return (
    <>
      <SchemaOrg type="CollectionPage" data={{
        name: `人人美剧 - ${categoryName}美剧`,
        description: `人人美剧${categoryName}分类，提供最新${categoryName}类美剧免费在线观看，高清中英文字幕，每日更新。`,
        url: `https://www.renrenmeiju.com/category/${activeSlug}`,
        isPartOf: { '@type': 'WebSite', name: '人人美剧', url: 'https://www.renrenmeiju.com/' },
      }} />

      <Navbar />

      <main className="pt-16">
        <div className="px-4 md:px-6 py-6 md:py-8">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[{ label: '分类浏览' }, { label: categoryName }]} />

            <div className="mb-8">
              <h1 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
                {categoryName === '全部' ? '全部美剧' : `${categoryName}美剧`}
              </h1>
              <p className="text-foreground-600 text-sm">
                {categoryName === '全部'
                  ? '浏览人人美剧平台上的所有美剧资源，涵盖剧情、悬疑、科幻、喜剧、动作、恐怖、动画等全类型。'
                  : `人人美剧为您精选${categoryName}类美剧，高清画质，中英文字幕，每日更新。`}
              </p>
            </div>

            <div className="mb-8">
              <CategoryTabs categories={categories} activeSlug={activeSlug} onCategoryChange={handleCategoryChange} />
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {filteredShows.map((show) => (
                <ShowCard key={`cat-${show.id}`} show={show} size="small" />
              ))}
            </div>

            {filteredShows.length === 0 && (
              <div className="text-center py-20">
                <span className="w-16 h-16 flex items-center justify-center mx-auto mb-4 text-foreground-300">
                  <i className="ri-emotion-sad-line text-4xl"></i>
                </span>
                <p className="text-foreground-500">暂无该分类的美剧资源</p>
              </div>
            )}

            <div className="mt-10 text-center">
              <p className="text-sm text-foreground-500">
                共 <strong className="text-foreground-950">{filteredShows.length}</strong> 部{categoryName !== '全部' ? categoryName : ''}美剧
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}